import { Accordion, AccordionItem } from '@spark-web/accordion';
import { Box } from '@spark-web/box';
import { Button } from '@spark-web/button';
import { Divider } from '@spark-web/divider';
import { ContentDialog } from '@spark-web/modal-dialog';
import { Text } from '@spark-web/text';
import { INCOME_VERIFICATION, OPEN_BANKING_INCOME_DETAILS } from '@utils';

interface OpenBankingCalculationExplanationModalProps {
  isOpen: boolean;
  onToggle: () => void;
}

export function OpenBankingCalculationExplanation({ isOpen, onToggle }: OpenBankingCalculationExplanationModalProps) {
  const {
    CDR_REVIEW_EXPLANATION_TITLE,
    CDR_REVIEW_EXPLANATION_DESCRIPTION,
    CDR_REVIEW_QUESTION_1,
    CDR_REVIEW_QUESTION_1_ANSWER,
    CDR_REVIEW_QUESTION_2,
    CDR_REVIEW_QUESTION_2_ANSWER,
    CDR_REVIEW_QUESTION_3,
    CDR_REVIEW_QUESTION_3_ANSWER,
  } = OPEN_BANKING_INCOME_DETAILS;

  return (
    <>
      <ContentDialog title={CDR_REVIEW_EXPLANATION_TITLE} isOpen={isOpen} onToggle={onToggle}>
        <Text>{CDR_REVIEW_EXPLANATION_DESCRIPTION}</Text>
        <Accordion type="multiple">
          <AccordionItem value="item-1" label={CDR_REVIEW_QUESTION_1} level="4">
            <Text tone="muted">{CDR_REVIEW_QUESTION_1_ANSWER}</Text>
          </AccordionItem>
          <Divider />
          <AccordionItem value="item-2" label={CDR_REVIEW_QUESTION_2} level="4">
            <Text tone="muted">{CDR_REVIEW_QUESTION_2_ANSWER}</Text>
          </AccordionItem>
          <Divider />
          <AccordionItem value="item-3" label={CDR_REVIEW_QUESTION_3} level="4">
            <Text tone="muted">{CDR_REVIEW_QUESTION_3_ANSWER}</Text>
          </AccordionItem>
          <Divider />
        </Accordion>
        <Box alignSelf="end">
          <Button onClick={onToggle}>Close</Button>
        </Box>
      </ContentDialog>
    </>
  );
}
